import { Product } from './product';
import { SalesActionEnum } from './sales-action-enum';

export class MembershipProductDependency {
  id: number;
  salesAction: SalesActionEnum;
  childProduct: Product;
  required: boolean;
}
